module.exports = __webpack_public_path__ + "img/money2x.d48f5606.png";